export const AE = 'ae';
export const AM = 'am';
export const AT = 'at';
export const BA = 'ba';
export const CR = 'cr';
export const DE = 'de';
export const EG = 'eg';
export const GE = 'ge';
export const GT = 'gt';
export const KG = 'kg';
export const KR = 'kr';
export const KW = 'kw';
export const KZ = 'kz';
export const MA = 'ma';
export const MD = 'md';
export const MK = 'mk';
export const MX = 'mx';
export const PMI = 'pmi';
export const RE = 're';
export const RS = 'rs';
export const SA = 'sa';
export const SE = 'se';
export const TN = 'tn';
export const UAT = 'uat';
export const UZ = 'uz';
export const ZA = 'za';
export const AL = 'al';
